import React from 'react'
import { MenuList } from '@material-ui/core'
import {
  PLACE_INVITATION_ADDED,
  PLACE_INVITATION_INVITED,
  PLACE_INVITATION_PENDING_REQUEST,
} from 'app/configs/statusConfigs'
import Approve from './Approve'
import Reject from './Reject'
import Delete from './Delete'
import MarkCorrect from './MarkCorrect'
import ReInvited from './Re-Invited'
import { CHANNEL_EMAIL, CHANNEL_SMS } from 'app/constants/channel'
import Invite from './Invite'
import { useIsRootAdmin } from 'commons/useUserProfile'
import MoreVertMenu from 'app/componentV4/Menu/MoreVertMenu'

const isEmailOrSmsChannel = (channel) =>
  channel === CHANNEL_SMS || channel === CHANNEL_EMAIL

function SubscriberAction({
  subscriberId,
  channel,
  status,
  hasBadContact,
  isHorizontal = false,
  handleInvite,
  handleReInvite,
  handleDelete,
  handleApprove,
  handleReject,
  handleMarkCorrect,
}) {
  const isRootAdmin = useIsRootAdmin()

  return (
    <>
      {isRootAdmin(subscriberId) ? null : (
        <MoreVertMenu icon={isHorizontal ? 'more_horiz' : 'more_vert'}>
          {(closeMenu) => (
            <MenuList className="w-full">
              {status === PLACE_INVITATION_INVITED &&
              isEmailOrSmsChannel(channel) ? (
                <ReInvited
                  closeMenu={() => closeMenu()}
                  onAction={handleReInvite}
                />
              ) : null}
              {status === PLACE_INVITATION_ADDED &&
              isEmailOrSmsChannel(channel) ? (
                <Invite closeMenu={() => closeMenu()} onAction={handleInvite} />
              ) : null}

              {status === PLACE_INVITATION_PENDING_REQUEST && (
                <div>
                  <Approve
                    closeMenu={() => closeMenu()}
                    onAction={handleApprove}
                  />
                  <Reject
                    closeMenu={() => closeMenu()}
                    onAction={handleReject}
                  />
                </div>
              )}
              {hasBadContact && (
                <MarkCorrect
                  closeMenu={() => closeMenu()}
                  onAction={handleMarkCorrect}
                />
              )}
              <Delete closeMenu={() => closeMenu()} onAction={handleDelete} />
            </MenuList>
          )}
        </MoreVertMenu>
      )}
    </>
  )
}

export default SubscriberAction
